export const STAFF = "staff"
export const TECHNICAL = "technical"
export const NORMAL = "normal"
